import script from "./MessageComposer.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageComposer.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__